import React, { useEffect, useState } from "react";
import { useLocation, withRouter } from "react-router-dom";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { Col, Row } from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import { ApiEvent } from "./ApiEvent";

const SelectiveEventParticipants = ({
  type,
  participants,
  setParticipants,
}) => {
  const location = useLocation();
  const eventId = location.state.eventId;
  const unitId = location.state.eventUnitId;
  const [members, setMembers] = useState([]);
  const [name, setName] = useState("null");
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      ApiEvent()
        .searchMembersforEventParticipants(unitId, true, name, type)
        .then((res) => {
          setMembers(res.data);
        })
        .catch((err) => console.log(err));
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [name, unitId, type]);

  const handleOnSearch = (string) => {
    setName(string);
  };

  const formatResult = (item) => {
    var str = item;
    let remove = str.split(" - ").pop();
    let reqiuredName = str.replace(" - " + remove, "   ");
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          <b>{reqiuredName}</b> - {remove.replace("/ ", "  ")}
        </span>
      </>
    );
  };

  const handleOnSelect = (item) => {
    const exists = participants.some(
      (m) => m.memberId === item.id
    );
    if (!exists) {
      const newParticipant = {
        memberId: item.id,
        eventId: eventId,
        name: item.name,
        memberType: item.memberType,
        memberRegNo: item.memberRegNo,
        memberUnitName: item.memberUnitName,
        attendanceStatus: 1,
        onTime: true,
      };
      setParticipants([...participants, newParticipant]);
    }
  };

  return (
    <div>
      <div className="ibox">
        <div className="ibox-title">
          <h5>
            {
              <GetLanguageString
                props={
                  type === "rafiq"
                    ? "participant_add_rafiq"
                    : "participant_add_habib"
                }
              />
            }
          </h5>
        </div>
        <div className="ibox-content">
          <Row>
            <Col md="12" className="ur">
              <ReactSearchAutocomplete
                styling={{ zIndex: "1", fontFamily: "Mehr Nastaleeq" }}
                items={members}
                onSearch={handleOnSearch}
                onSelect={handleOnSelect}
                autoFocus
                formatResult={formatResult}
                // onClear={handleOnClear}
              />
            </Col>
          </Row>
          {/* {selectedName !== "select" ? (
              <>
                <Row className="m-t-lg">
                  <Col md="3">
                    <b>
                      <Label>
                        {
                          <GetLanguageString props="events_participants_time_status" />
                        }
                      </Label>
                    </b>
                  </Col>
                </Row>
                <Row className="m-t">
                  <Col md="3">
                    <Label
                      className="form-check form-check-inline"
                      for={"onTime" + type + members.id}
                    >
                      <Input
                        id={"onTime" + type + members.id}
                        checked={onTime}
                        type="checkbox"
                        name={"onTime" + members.id}
                        onChange={handleOnTime}
                        className="form-check-input"
                      />
                      {
                        <GetLanguageString props="events_participants_on_time" />
                      }
                    </Label>
                  </Col>
                  <Col md="6">
                    <Label
                      className="form-check form-check-inline"
                      for={"absent" + type + memberId}
                    >
                      {attendanceStatus === 0 ? (absent = true) : null}
                      <Input
                        id={"absent" + type + memberId}
                        type="radio"
                        checked={absent}
                        name={"status" + memberId}
                        onChange={() => handleAttendanceStatus(0)}
                        className="form-check-input"
                      />
                      {
                        <GetLanguageString props="events_participants_attendance_absent" />
                      }
                    </Label>
                    <Label
                      className="form-check form-check-inline"
                      for={"present" + type + memberId}
                    >
                      {attendanceStatus === 1 ? (present = true) : null}
                      <Input
                        id={"present" + type + memberId}
                        type="radio"
                        checked={present}
                        name={"status" + memberId}
                        onChange={() => handleAttendanceStatus(1)}
                        className="form-check-input"
                      />
                      {
                        <GetLanguageString props="events_participants_attendance_present" />
                      }
                    </Label>
                    <Label
                      className="form-check form-check-inline"
                      for={"leave" + type + memberId}
                    >
                      {attendanceStatus === 2 ? (leave = true) : null}
                      <Input
                        id={"leave" + type + memberId}
                        checked={leave}
                        type="radio"
                        name={"status" + memberId}
                        onChange={() => handleAttendanceStatus(2)}
                        className="form-check-input"
                      />
                      {
                        <GetLanguageString props="events_participants_attendance_leave" />
                      }
                    </Label>
                  </Col>
                  <Col md="2">
                    <Button color="primary" size="sm" onClick={handleOnSave}>
                      {<GetLanguageString props="common_save" />}
                    </Button>
                  </Col>
                </Row>
              </>
            ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(SelectiveEventParticipants);
